<template>
  <book-carousel-pop-up
    :titleCarousel="$t('library.title_carousel_2')"
    :subTitleCarousel="$t('library.subtitle_carousel_2')"
    :booksList="topMostRequestedBooksList"
    :mostPopular="true"
    class="popular"
    />
</template>

<script>
let Airtable = null;

import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import _ from 'lodash';
import BookCarouselPopUpVue from '@/components/library/BookCarouselPopUp.vue'
import bookService from '../../services/book'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  data() {
    return {
      mostRequestedBooks: {
          code: 0,
          data: [],
      },
      loading: false,
      last: false,
      empty: false,
    }
  },
  created() {
        this.getMostRequestedBooksPage()
    },
    mounted() {},
    props: ['mostPopular'],
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            user_id: (state) => state.userData.user.id,
            user: (state) => state.userData.user,
            grade: (state) => state.userData.user.course.ordinalGrade,
        }),
        topMostRequestedBooksList() {
            return this.mostRequestedBooks
        },
    },
    components: {
        'book-carousel-pop-up': BookCarouselPopUpVue,
        VueSlickCarousel,
    },
    methods: {
        getMostRequestedBooksPage() {
            bookService
                .getMostRequestedBooksPage(this.grade)
                .then((response) => {
                    if (response && response.content && response.content.length > 0) {
                        this.mostRequestedBooks = {
                            code: 1,
                            data: response.content,
                        }
                    } else {
                        this.mostRequestedBooks = {
                            code: 2,
                            data: [],
                        }
                    }
                })
                .catch((error) => {
                    Sentry.captureException(error)
                    this.mostRequestedBooks = {
                        code: 3,
                        error,
                    }
                })
        },
    },
}
</script>

<style>

</style>